var m = require('mithril');
var animations = require('../../libs/animations');
var session = require('../../auth/models/session');
var boolBox = require('../../components/boolBox');
var Point = require('../models/point');
var pointTrendModal = require('./pointTrendModal');
var pointSubscriber = require('../../../javascripts/components/pointSubscriberClass')

var pointValue = {
  oninit : function (vnode) {
    this.column = vnode.attrs;
  },
  onupdate:function (vnode) {
    if(this.column.in['@rid'] != vnode.attrs.in['@rid']){
      this.pointSubscriberObj.unsubscribe(this);  
      this.column = vnode.attrs;
      this.pointSubscriberObj.subscribe(this);
    }
  },
  oncreate: function () {
    this.pointSubscriberObj = new pointSubscriber();
    this.pointSubscriberObj.subscribe(this);
  },
  onremove: function () {
    this.pointSubscriberObj.unsubscribe(this);
  },
  view: function () {
    var ctrl =this
    var tdSelector = 'td.tc.bb-0.bl-0.b--dotted.bw1';
    var clickFunction = function (e) {
      e.preventDefault();
      pointTrendModal.open(ctrl.column);
    };

    if (ctrl.column.in.unit === 'bool') {
      return m(boolBox, {
        column: ctrl.column,
        pointRecord: ctrl.column.in,
        clickFunction: clickFunction,
        href: '#',
        linkTitle: 'View trend chart',
        tdSelector: tdSelector
      });
    }

    var displayValue = Point.readValue(ctrl.column.in) || '';
    var displayColor = (Number(ctrl.column.in.overrideActive) ? '.yellow' :  (ctrl.column.in.alarmStatus == 'Alarm Tripped' ? '.red' : '.blue'))
    var valueSpan;
    var textDecStyles = {
      'text-decoration': Date.now() - ctrl.column.in.time > 60000 ? 'line-through' : '',
    };

    if (Number(session.user().typewriterEffect)) {
      valueSpan = [
        m('span.ma0' + displayColor, {
          typewriterString: displayValue,
          onupdate: animations.typer,
          style: textDecStyles,
        }, displayValue),
      ];
    } else {
      valueSpan = m('span.ma0' + displayColor, { style: textDecStyles }, displayValue);
    }

    return m(tdSelector, [
      m('a.ph1.f4.pointer.flex.justify-center.tl', {
        onclick: clickFunction, 
        href: '#',
        'aria-haspopup': 'dialog',
        title: 'View trend chart',
        'data-point-rid': ctrl.column.in['@rid']
      }, [
        m('span.moon-gray', { style: { minWidth: displayValue.length + 'ch' } }, valueSpan),
        m('span.v-top.dib.moon-gray', {style: {fontSize: '10px'}}, '  ' + Point.formatUnit(ctrl.column.in))
      ])
    ])
  }
};

module.exports = pointValue;
